import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from '@src/components/Link';
import './styles.scss';

export default function LegacyButton({ children, theme, isLink, style = 'primary', className, ...props }) {
  props.href = props.disabled ? 'javascript:void(0)' : props.href;

  return React.createElement(
    isLink ? (props.to ? Link : 'a') : 'button',
    {
      className: classnames('frank-button', props.disabled && 'disabled', style, theme, className),
      ...props,
    },
    children,
  );
}

LegacyButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  isLink: PropTypes.bool,
  style: PropTypes.oneOf(['secondary', 'pill']),
  theme: PropTypes.oneOf([
    'transparent',
    'transparent-link',
    'transparent-red',
    'transparent-pink',
    'transparent-green',
    'transparent-gray',
    'transparent-blue',
    'transparent-purple',
    'transparent-orange',
    'white-purple',
    'white',
    'red',
    'pink',
    'purple',
    'blue',
    'danger',
    'orange',
    'green',
    'light-purple',
  ]),
  to: PropTypes.string,
};
